<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-hotel-menutab [isEdit]="isEdit" [nameMenu]="nameMenu" [branchofficeSlug]="branchofficeSlug"
      [checkId]="checkId"></app-hotel-menutab>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Galería videos / {{item.value.tradename}}<span
              class="text-success"></span>
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <a class="btn btn-light d-inline" (click)="refresh()"><i class="fas fa-undo"></i> Recargar</a>
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-12 m-b-10">
              <!-- <a class="btn btn-info btn-sm pointer" (click)="addItemVideo()">
                Agregar item <i class="fa fa-plus"></i></a> -->
              <span class="badge badge-info bold float-right">
                <i class="fas fa-info-circle m-r-5"></i>
                No olvider guardar para aplicar cambios
              </span>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-12 p-0">
                <ng-container *ngIf="videosUpload.length > 0">
                  <div class="card" *ngFor="let item of videosUpload; let index_ = index">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-lg-6 col-12">
                          <textarea id="iframe_video{{index_}}" required rows="4"
                            (keyup)="changeIframeVideo($event.target, index_)" class="form-control no-resize"
                            placeholder="Copiar el enlace 'embed' del video de youtube"> {{item.iframe_video}}</textarea>
                          <div class="input-group m-t-10">
                            <div class="input-group-prepend">
                              <span class="input-group-text">Titulo video (Opcional)</span>
                            </div>
                            <input type="text" class="form-control" (keyup)="changeTitleVideo($event.target, index_)"
                              value="{{item.title}}">
                            <i class="far fa-trash-alt pointer f-s-15 text-danger m-t-5 m-l-5"
                              (click)="removeVideo(index_)"></i>
                          </div>
                        </div>
                        <div class="col-lg-6 col-12">
                          <ng-container *ngIf="item.is_generate_iframe">
                            <div class="content-iframe" [innerHTML]="item.iframe_video | safe"> </div>
                          </ng-container>
                          <ng-container *ngIf="!item.is_generate_iframe">
                            <span style="color: rgb(158, 155, 155);">Asegúrese de ingresar un iframe correcto</span>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 m-b-10">
              <a class="btn btn-info btn-sm pointer" (click)="addItemVideo()">
                Agregar item <i class="fa fa-plus"></i></a>                  
            </div>
          </div>
          <div class="form-group col-lg-12 form__footerBtn">
            <div class="text-right">
              <a class="btn btn-secondary" (click)="cancel()">Cancelar</a>
              <button type="submit" class="btn btn-primary waves-effect waves-light">
                <i class="far fa-save m-r-5"></i>
                Guardar
                Cambios
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
